/** 获取mock变量 */
export const getMockVar = (key: string) => (window as any).__mock__?.[key];
